import type { FaireProductEntity } from "../../entity_types/product";

export const p_s8mwgeq2vj: FaireProductEntity = {
  token: "p_s8mwgeq2vj",
  type: "product",
  name: "Enchanted Bath Bomb for Girls (1 Pack)",
  brandToken: "b_on2vzm5lxj",
  brandName: "Two Sisters Spa",
  imageUrl:
    "https://cdn.faire.com/fastly/792d1aeced7bf5934603b8ad47b8b97952170426e9e4a53e723be74837ba5918.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9d6f029e2239005b409fc8f464bba9f62f4fb06939766714032aaab0b83d393c.jpeg",
    "https://cdn.faire.com/fastly/278d205468bace524ce0cbc0b2ec4ac94249e0025b4861faa1e2dbc4567bd7d8.jpeg",
    "https://cdn.faire.com/fastly/5646dc4a448fa736f2da8eb26cf568ac91238090ad6510986d18905446d2f8d9.jpeg",
    "https://cdn.faire.com/fastly/7a899ff9aecebfda26d82d76e211b55eff287c62ddf42af5e4ff990e74944054.jpeg",
    "https://cdn.faire.com/fastly/1b51292aac1e09b9c063838232611b70f6cac23746ba8caaae683b78c03b7cec.jpeg",
    "https://cdn.faire.com/fastly/18bb722300031bf927dc5602552c9fecc1e4e3df91311e1ed0592dd0956b9bfd.jpeg",
    "https://cdn.faire.com/fastly/189453440e4f086dd9ef7d0d76851533b947d27177909400f964fbb388a99cb5.jpeg",
    "https://cdn.faire.com/fastly/2d9703e174734284abe24de8639b8c24f004cada051123c56c4cd930ac58b3e2.jpeg",
  ],
  priceDollars: 4.5,
  description:
    'Surprise Kids Bath Bombs:\nExperience the magic of our fizzy bath bombs, revealing surprise enchanted princess toys from our favorite fairytales. Immerse your kids in a bath filled with vibrant colors and bubbles that last 5 to 8 minutes—longer than other bath bombs on the market.\n\nHidden Princess Toys Inside: \nEach handmade bubble bath bomb contains a surprise bath toy! Hides a collectible figure inspired by your enchanted characters—perfect for creative builders and adventurers.\n\nBubble Bath Bomb Scents:\nFruit Punch, Citrus, Tropical Fruit, Fruit Loops, Berry, and Grape.\n\nSafe & Trusted Ingredients + No Stains:\nMade in the USA with a kid-friendly "SLSa" formula, our bath bombs are free from common irritants. They won’t leave color stains or rings around the tub, ensuring a fun and safe bath time.\n\nAll Two Sisters Bubble Bath Bombs:\nAre activated to maximum bubbly-ness by your tub faucet water pressure (drop them in as you fill your tub to watch the magic happen!)\n\nCan be used after you fill up the tub for a more traditional bath bomb experience\nLeave your body relaxed and your skin super soft\n\nWarning: Small Parts. Not recommended for children under the age of 3.\n',
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:31.201Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
